import { 
  Series, 
  AbsoluteFill, 
  useCurrentFrame, 
  interpolate, 
  Video,
  staticFile // 👈 1. Import staticFile
} from 'remotion';

// 2. Remove the old import statement:
// import myVideo from './assets/my-video.mp4'; 

// 3. Create a variable using staticFile():
const videoSrc = staticFile('my-video.mp4');

const FPS = 30;

export const RewindEffect: React.FC = () => {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill style={{ backgroundColor: 'black' }}>
      <Series>
        {/* Part 1: Play the first 3 seconds normally */}
        <Series.Sequence durationInFrames={3 * FPS}>
          <Video src={videoSrc} />
        </Series.Sequence>

        {/* Part 2: Rewind those 3 seconds in just 1 second */}
        <Series.Sequence durationInFrames={1 * FPS}>
          <Video
            src={videoSrc}
            startFrom={interpolate(
              frame - 3 * FPS,
              [0, 1 * FPS],
              [3 * FPS, 0]
            )}
          />
        </Series.Sequence>

        {/* Part 3: Replay the first 3 seconds normally again */}
        <Series.Sequence durationInFrames={3 * FPS}>
          <Video src={videoSrc} />
        </Series.Sequence>
      </Series>
    </AbsoluteFill>
  );
};